




























import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import BulkUpdateRequest from '@/models/BulkUpdateRequest';
import { monthOptions } from '@/utils/utils';

@Component({
  components: {
    PriceInput: () => import('@/components/PriceInputWithCurrency.vue'),
    Multiselect: () => import('vue-multiselect'),
    AppTooltip: () => import('@/components/AppTooltip.vue'),
  },
  computed: {
    ...mapState(['dashboard']),
    ...mapGetters(['roomsNeedOnboardPrice']),
  },
})
export default class OnboardAvailabilityForm extends Vue {
  @PropSync('loading', {required: false, default: false}) public isLoading!: boolean;
  @PropSync('error', {required: false, default: false}) public showError!: boolean;
  public monthOptions: any[] = monthOptions.map((option: any) =>
    ({...option, label: this.$root.$i18n.t(option.label)}));
  public applyMonth: any = this.monthOptions[0];
  public rooms: any = [];
  public selectedRoomId: any;
  public errors: any = {};
  public validForm: boolean = false;
  public roomsNeedOnboardPrice!: any;
  private dashboard!: any;

  public handleError(hasError: boolean) {
    if (this.selectedRoomId) { this.errors[this.selectedRoomId] = hasError; }
    this.validForm = Object.values(this.errors).every((err: any) => !err);
  }

  public async updatePricing() {
    try {
      this.isLoading = true;
      const endDate = moment().add(this.applyMonth.value, 'M').format('YYYY-MM-DD');
      const payloads = this.rooms.map((item: any) => (
        { ...item, endDate, amount: Math.round(Number(item.amount.toString().replace(',', '.')) * 100) }
      ));
      await Promise.all(payloads.map((payload: any) => (this.$store.dispatch('bulkPriceUpdate', payload))));
      this.$store.dispatch('getDashboardData', {
        start: this.dashboard.dateRange.start,
        end: this.dashboard.dateRange.end,
      });
      const from = moment().format('MMMM');
      const to = moment(endDate).format('MMMM');
      const length = this.applyMonth.value;
      const message = this.applyMonth.value > 1
        ? 'onboard.message.success.price.content'
        : 'onboard.message.success.price.oneMonthContent';
      this.$emit('updatePricingSuccess', { message, appliedDate: { from, to, length }});
    } catch (e) {
      this.showError = true;
      setTimeout(() => this.showError = false, 15000);
    } finally {
      this.isLoading = false;
    }
  }

  @Watch('roomsNeedOnboardPrice', {immediate: true})
  private fetchForm(rooms: any) {
    if (rooms && rooms.length) {
      this.rooms = rooms.map((room: any) =>
        ({...new BulkUpdateRequest(room.id, false), amount: 0}));
      rooms.forEach((room: any) => {
        this.errors[room.id] = true;
      });
    }
  }
}
